import { render, staticRenderFns } from "./PriceAnnexe.vue?vue&type=template&id=7879462b"
import script from "./PriceAnnexe.vue?vue&type=script&lang=ts"
export * from "./PriceAnnexe.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports